export default __webpack_public_path__ + "static/media/picture4.27c70c4d.png";